/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { AppState } from '../types'
import { searchCountry } from '../redux/actions'

export default function useCountries(
  search: any,
  sortCountry: any,
  reverseSort: any
) {
  const countries = useSelector((state: AppState) => state.countries.countries)
  const filteredCountries = useSelector(
    (state: AppState) => state.countries.filteredCountries
  )

  const dispatch = useDispatch()

  const [data, setData] = useState(Array)
  const [err, setError] = useState(null)
  const [flag, setFlag] = useState(false)

  useEffect(() => {
    let errMessage = 'There was a problem loading the data. Refresh the page.'
    if (err) {
      setError(errMessage as any)
    }

    if (countries.length > 0) {
      setData(countries)
    }
  }, [data, countries])

  useEffect(() => {
    setData(filteredCountries)
  }, [filteredCountries])

  useEffect(() => {
    sortCountries(data)
  }, [sortCountry, reverseSort])

  const searchCountryResults = useCallback(() => {
    const results = countries.filter((country: any) => {
      if (country.altSpellings.length > 0) {
        //Antartica has no alt names so should be excluded, else it will return an error, so we check all arrays bigger than 0
        let altName = country.altSpellings.reduce((accum: any, curr: any) => {
          return accum + ' ' + curr
        })
        if (
          country.name.common.includes(search) ||
          country.name.common.toLowerCase().includes(search) ||
          altName.includes(search) ||
          altName.toLowerCase().includes(search) ||
          country.region.includes(search) ||
          country.region.toLowerCase().includes(search) ||
          country.population.toString().includes(search)
        ) {
          return country
        }
      }
    })
    setData(results)

    dispatch(searchCountry(results as any))
  }, [countries, search, dispatch])

  useEffect(() => {
    searchCountryResults()
  }, [search, searchCountryResults])

  const sortCountries = useCallback(
    (countries: any) => {
      if (sortCountry === 'name') {
        const sortByName = countries.sort((a: any, b: any) =>
          a.name.common > b.name.common ? 1 : -1
        )
        setData(flag ? sortByName : sortByName.reverse())
      }
      if (sortCountry === 'population') {
        const sortByPopulation = countries.sort((a: any, b: any) =>
          a.population > b.population ? 1 : -1
        )
        setData(flag ? sortByPopulation : sortByPopulation.reverse())
      }
      if (sortCountry === 'region') {
        const sortByRegion = countries.sort((a: any, b: any) =>
          a.region > b.region ? 1 : -1
        )
        setData(flag ? sortByRegion : sortByRegion.reverse())
      }

      setFlag(!flag)
    },
    [flag, countries, sortCountry]
  )

  return [err, data, sortCountry]
}
